import { combineReducers } from "redux";
import { agentSlice } from "../modules/agentlist/redux/AgentSlice";
import { cashierSettingSlice } from "../modules/cashierSetting/redux/CashierSettingSlice";
import { changePasswordSlice } from "../modules/changePassword/redux/ChangePasswordSlice";
import { companyGameSlice } from "../modules/companyGame/redux/CompanyGameSlice";
import { dashboardSlice } from "../modules/dashboard/redux/DashboardSlice";
import { mainSlice } from "../modules/main/redux/MainSlice";
import { memberSlice } from "../modules/memberlist/redux/MemberSlice";
import { messageBoxSlice } from "../modules/messageBox/redux/MessageBoxSlice";
import { platformSettingSlice } from "../modules/platformSetting/redux/PlatfromSettingSlice";
import { accountCreditSlice } from "../modules/projectCredit/redux/ProjectCreditSlice";
import { promotionSlice } from "../modules/promotion/redux/PromotionSlice";
import { refundNPromotionSlice } from "../modules/refundNPromotion/redux/RefundNPromotionSlice";
import { reportSlice } from "../modules/report/redux/ReportSlice";
import { searchSlice } from "../modules/searchByUsername/redux/SearchSlice";
import { subAgentSlice } from "../modules/subagentlist/redux/SubAgentSlice";
import { transactionSlice } from "../modules/transaction/redux/TransactionSlice";
import { vipCommissionSlice } from "../modules/vipCommission/redux/VipCommissionSlice";
import { vipEvaluateSlice } from "../modules/vipEvaluate/redux/VipEvaluateCommissionSlice";
import { vipGameCommissionSlice } from "../modules/vipGameCommission/redux/VipGameCommissionSlice";
import { vipHistorySlice } from "../modules/vipHistory/redux/VipHistorySlice";
import { vipListSlice } from "../modules/vipList/redux/VipListSlice";
import { vipVipCommissionSlice } from "../modules/vipVipCommission/redux/VipVipCommissionSlice";
import { vipVipHistorySlice } from "../modules/vipVipHistory/redux/VipVipHistorySlice";

export const rootReducer = combineReducers({
  dashboard: dashboardSlice.reducer,
  changePassword: changePasswordSlice.reducer,
  main: mainSlice.reducer,
  subAgent: subAgentSlice.reducer,
  agent: agentSlice.reducer,
  member: memberSlice.reducer,
  search: searchSlice.reducer,
  platformSetting: platformSettingSlice.reducer,
  report: reportSlice.reducer,
  transaction: transactionSlice.reducer,
  accountCredit: accountCreditSlice.reducer,
  refundNPromotion: refundNPromotionSlice.reducer,
  promotion: promotionSlice.reducer,
  messageBox: messageBoxSlice.reducer,
  vipList: vipListSlice.reducer,
  vipCommission: vipCommissionSlice.reducer,
  vipGameCommission: vipGameCommissionSlice.reducer,
  vipHistory: vipHistorySlice.reducer,
  vipEvaluate: vipEvaluateSlice.reducer,
  vipVipCommission: vipVipCommissionSlice.reducer,
  vipVipHistory: vipVipHistorySlice.reducer,
  cashierSetting: cashierSettingSlice.reducer,
  companyGame: companyGameSlice.reducer,
});
